export class ProductSize
{
	public DisplayOrder;
	public DisplayPrice;
	public RegularPrice;
	public Size;
	public SizeID;

	constructor(sizeID, size, displayPrice, regularPrice, displayOrder)
	{
		this.Size = size;

		this.SizeID = parseInt(sizeID, 10);
		this.SizeID = isNaN(this.SizeID) ? 0 : this.SizeID;

		this.DisplayPrice = parseFloat(displayPrice);
		this.DisplayPrice = isNaN(this.DisplayPrice) ? 0 : this.DisplayPrice;

		this.RegularPrice = parseFloat(regularPrice);
		this.RegularPrice = isNaN(this.RegularPrice) ? 0 : this.RegularPrice;

		this.DisplayOrder = parseInt(displayOrder, 10);
		this.DisplayOrder = isNaN(this.DisplayOrder) ? 0 : this.DisplayOrder;
	}
}